export default {
  id: 'WeekdateSelect',
  code: 'CN',
  text: {
    'Monday': '星期一',
    'Tuesday': '星期二',
    'Wednesday': '星期三',
    'Thursday': '星期四',
    'Friday':'星期五',
    'Saturaday': '星期六',
    'Sunday': '星期日'
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Fields/WeekdateSelect/locale.js